<template>
  <div>
    <div class="x">
      <el-dialog :visible.sync="dialogVisible" width="70%" :before-close="closeDialog">
        <div slot="title" class="header-title">
          <span class="title-name"></span>
          <span class="title-age">纳排标准-{{ projectName }} {{ questionnaireName ? '-' + questionnaireName : '' }}</span>
        </div>
        <!-- <div style="margin-bottom: 20px" class="div_select"></div> -->
        <!-- <div class="btn">
          <button @click="bindDialog = false">取消</button>
          <button type="primary" @click="bindAdd">确定</button>
        </div> -->
        <!-- 双id -->
        <div v-if="this.Qid" v-loading="loading">
          <div class="form">
            <div v-if="x" class="nbSearch">
              <!-- 内容 -->
              <div style="display: flex; margin-top: 20px">
                <!-- <div style="margin-left: 40px">纳排标准：</div> -->
                <el-input :autosize="{ minRows: 2, maxRows: 10 }" show-word-limit readonly style="width: 75%; font-size: 14px" v-model="x" type="textarea" placeholder=""></el-input>
              </div>
            </div>
            <div v-else>
              <div>暂未添加纳排标准</div>
            </div>
          </div>
        </div>
        <!-- id都有 -->
        <div v-if="!this.Qid" v-loading="loading">
          <el-collapse v-if="testArr.length" v-model="activeNames">
            <template>
              <el-collapse-item :title="itemx.Name ? '问卷——' + itemx.Name : ''" :name="indexx" v-for="(itemx, indexx) in testArr" :key="indexx">
                <!-- 内容 -->
                <div style="color: red" v-if="itemx.ProjectRuleList.length == 0">暂未添加纳排标准</div>
                <div v-if="itemx.ProjectRuleList.length != 0" style="display: flex; margin-top: 50px">
                  <el-input :autosize="{ minRows: 2, maxRows: 10 }" show-word-limit readonly style="width: 75%; font-size: 14px" v-model="itemx.Remarks" type="textarea" placeholder=""></el-input>
                </div>
              </el-collapse-item>
            </template>
          </el-collapse>
          <div v-else>项目暂未添加纳排标准</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import naPai from '@/api/naPai';
import smartSearch from '@/api/smartSearch.js';
import { opAndOr, opRelations, opRelations2, optionsTime } from '@/utils/dictionary.js';
export default {
  name: '',
  components: {},
  props: {
    id: {
      type: String,
      default: ''
    },
    projectName: {
      type: String,
      default: ''
    },
    Qid: {
      type: String,
      default: ''
    },
    questionnaireName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      ProjectId: this.id,
      x: '',
      dialogVisible: false,
      pageSet: {
        key: '',
        page: 1,
        rows: 200
      },
      nbForm: [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ],
      options: [],
      opRelations: opRelations,
      opRelations2: opRelations2,
      opAndOr: opAndOr,
      optionsTime: optionsTime,

      // 22222
      testArr: [],
      activeNames: []
    };
  },
  computed: {},
  created() {
    console.log(this.Qid, 132456);
    this.getList();
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog', false);
    },
    bindAdd() {},
    toClear() {
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
      console.log(123456);
    },
    // id都有
    getData2() {
      const params = {
        ProjectId: this.ProjectId,
        Qid: this.Qid
      };
      console.log(params, 9898);
      naPai.getList(params).then(e => {
        this.x = e.data.Remarks;
        this.nbForm = e.data.ProjectRuleList;
        this.loading = false;
        console.log(e);
      });
    },
    // 只有ProjectId
    getData1() {
      naPai.GetProjectRuleListByProjectId(this.ProjectId).then(e => {
        if (e.data.Status == -1) {
          this.$message.error(e.data.Message);
          return;
        }
        const arr = [];
        e.data.forEach((item, index) => {
          arr.push(index);
        });
        this.activeNames = arr;
        this.testArr = e.data;
        this.loading = false;
        console.log(this.activeNames);

        console.log(this.testArr);
      });
    },
    onSave() {
      // const params = {
      //   id: this.ProjectId,
      //   data: { projectRuleEntity: this.nbForm }
      // };
      // console.log(params);
      naPai.AddList(this.ProjectId, this.nbForm).then(e => {
        this.$message.success('保存成功');
      });
      console.log(this.nbForm);
    },
    // 查询条件下拉查询 现在  **********************
    getList() {
      this.selectLoading = true;
      smartSearch.GetList(this.pageSet).then(e => {
        if (this.Qid) {
          this.getData2();
        } else {
          this.getData1();
        }
        this.selectLoading = false;
        this.options = e.data;
        console.log(e, 123465);
      });
    },
    onRestFz() {
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
    },
    toAdd(item, index) {
      this.nbForm.push({
        ConditionalType: '',
        Vaule: '',
        SelectType: '',
        MaxVaule: '',
        MinVaule: '',
        EventConditional: 0
      });
    },
    // 高级关系
    changeRelation(val, index) {
      const arr = ['Vaule', 'MinVaule', 'MaxVaule', 'EventDay', 'EventDataMappingId', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },
    changeRelations(val, index) {
      const arr = ['EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },
    timeChange(item, index) {
      const arr = ['EventDay', 'EventDataMappingId', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      // this.$set(this.nbForm);
      console.log(item, index);
    },
    toDel(item, index) {
      if (this.nbForm.length === 1) {
        this.nbForm = [
          {
            ConditionalType: '',
            Vaule: '',
            EventConditional: 0
          }
        ];
        return;
      }
      this.nbForm.splice(index, 1);
      console.log(item, index);
    }
  }
};
</script>

<style lang="scss" scoped>
.x {
  .div_select {
    padding: 50px;
  }
  .btn {
    padding-bottom: 50px;
  }
}

.form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 50px;
  .demo-form-inline {
    .el-form-item {
      margin-right: 0;
    }
  }
  ::v-deep() {
    .el-form-item {
      margin-right: 10px !important;
    }
  }
}
.nbSearch {
  width: 100%;
  .nbSearch_child {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 15px;
    & > div:first-child {
      margin-right: 10px;
    }
    ::v-deep() {
      .el-select {
        margin-right: 10px !important;
      }
    }
  }
}
.flexAll {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #409eff;
  cursor: pointer;
}
.flexAll_end {
  height: 100%;
  display: flex;
  align-items: center;
}

.opAndOr {
  width: 100px;
}
.inputChose {
  width: 200px;
  margin-right: 10px;
}
.iconRight {
  margin-right: 5px;
}

.condition {
  color: #333333;
  font-size: 20px;
  padding: 0 8px;
  border-left: 3px solid #3388ff;
}
.czhi {
  /* background: #fff !important; */
}
/deep/ .el-textarea__inner {
  box-shadow: 0 0 5px #d4ddeb; /* 阴影的颜色、模糊度等属性 */
}
/deep/ .el-dialog__body {
  padding: 0 20px 30px 20px;
}
/deep/ .el-collapse-item__wrap {
  margin-top: -50px;
}

/deep/ .el-collapse-item__header {
  font-size: 20px;
}
</style>
